module.exports = __webpack_public_path__ + "static/media/YF50_2.74b57b03.jpg";